/**
 * @format
 * @快捷选择时间日期
 */

import React, { FC, useState, useEffect, forwardRef, useImperativeHandle } from 'react'
import styled from 'styled-components'
import moment, { Moment } from 'moment'
import { _$, Datepicker, Select, Option, Icon } from 'kpc-react'
import {
  date_range_config,
  IQuickRangeDateProps,
  getRangeDateValue,
  getRangeDateShortcuts,
  renderShortcuts
} from './constants'
import { formatDate, dayToSecond } from 'src/utils'
// import _ from 'lodash'

// ref返回的方法
export interface QuickRangeDateMethod {
  reloadDate?: () => void
}

const QuickRangeDate: FC<IQuickRangeDateProps> = forwardRef(
  (
    {
      className,
      defautlValue,
      changeValue,
      quickRange,
      showQucikBtn = true,
      optionalRange,
      optionalMaxDate,
      optionalDateRange,
      realoadIcon = true,
      dateDiff,
      showShortcuts = true,
      ...datepickerProps
    },
    ref
  ) => {
    const [dateValue, setDateValue] = useState<[number, number] | []>([]) //datepicker的value
    const [range, setRange] = useState('') // 快捷选择value
    const [currentDate, setCurrentDate] = useState<Moment>(optionalMaxDate || moment())
    const [disabledDate, setDisabledDate] = useState<{ start: Date; end: Date }>({
      start: undefined,
      end: undefined
    })

    // 初始化
    useEffect(() => {
      // 处理初始值 如果初始值是数组，将数组处理成moment
      if (Array.isArray(defautlValue)) {
        const [start, end] = defautlValue
        setDateValue(start && end ? [moment(start).unix() * 1000, moment(end).unix() * 1000] : [])
      } else if (typeof defautlValue === 'string') {
        // 如果初始值是string 则设置成button的值
        const dateKey = date_range_config[defautlValue] || defautlValue || ''
        setDateValue(getRangeDateValue(dateKey))
        setRange(dateKey)
      }
    }, [defautlValue])

    // button切换日期时【触发回调】
    const btnChange = value => {
      if (value) {
        value !== range && setRange(value)
        // 如果禁用秒的话 默认秒设置为0
        const rangeDateValue = getRangeDateValue(value)
        const updateDateTime = datepickerProps.disabledSeconds
          ? rangeDateValue.map(date => moment(date).set('second', 0).unix() * 1000)
          : rangeDateValue
        setDateValue(updateDateTime as [number, number])
        changeValue && changeValue(updateDateTime as [number, number], value)
      }
    }

    // 手动选择日期 && datapicker左侧快捷选择时 && 清除时 【触发回调】
    const handleChange = value => {
      if (value) {
        const dateValue = value?.map(date => moment(date).unix() * 1000)
        setDateValue(dateValue)
        const quickValue = getRangeDateShortcuts(dateValue)
        setRange(quickValue)
        changeValue && changeValue(dateValue || [], quickValue)
      } else {
        setCurrentDate(optionalMaxDate || moment())
        setDateValue([])
        setRange(undefined)
        changeValue && changeValue([], undefined)
      }
    }

    // disabled时分秒的时候 设置临时value(不会触发回调)
    const handleChangeValue = (_c, value) => {
      if (value?.length === 2) {
        const updateValue = value.map(date => moment(date).unix() * 1000)
        setDateValue(updateValue)
      }
    }

    // 计算disable最大/最小可选日期
    const _calcDisabledDate = (start: Date | string | number) => {
      let min = optionalDateRange
        ? moment(currentDate).subtract(optionalDateRange, 'day').toDate()
        : undefined
      if (dateDiff && start) {
        const calcMin = moment(start)?.add(-dayToSecond(dateDiff), 's').toDate()
        if (moment(calcMin)?.diff(moment(min)) > 0) {
          min = calcMin
        }
        let max = moment(start)?.add(dayToSecond(dateDiff), 's').toDate()
        if (moment(max)?.diff(currentDate) > 0) {
          max = currentDate.toDate()
        }
        return { min, max }
      } else {
        return {
          min,
          max: currentDate.toDate()
        }
      }
    }

    // 选择开始日期后计算禁用日期
    const selectStart = (_c, value) => {
      // 只选择开始时间时候，根据dateDiff计算可选择的日期
      if (dateDiff && value?.length === 1) {
        setCurrentDate(optionalMaxDate || moment())
        const startTime = formatDate(moment(value[0].$d))
        const { min, max } = _calcDisabledDate(startTime)
        setDisabledDate(({ start, end }) => ({ start: min || start, end: max || end }))
      }
      if (dateDiff && value?.length === 2) {
        setDisabledDate({
          start: optionalDateRange
            ? moment(currentDate).subtract(dayToSecond(optionalDateRange), 's').toDate()
            : undefined,
          end: currentDate.toDate()
        })
      }
    }

    // 根据当前时间重新计算日期可选范围
    // useEffect(() => {
    //   console.log('currentDate', currentDate)
    //   setDisabledDate({
    //     start: optionalDateRange
    //       ? moment(currentDate).subtract(dayToSecond(optionalDateRange), 's').toDate()
    //       : undefined,
    //     end: currentDate.toDate()
    //   })
    // }, [currentDate])

    // 导出重置
    useImperativeHandle(ref, () => ({
      reloadDate: () => reloadDate()
    }))

    // 刷新日期【触发回调】
    const reloadDate = () => {
      if (range) {
        btnChange(range)
      }
    }

    return (
      <div className={className}>
        {showQucikBtn && (
          // <ButtonGroup
          //   checkType="radio"
          //   value={range}
          //   on$change-value={(_c, value) => {
          //     btnChange(value)
          //   }}
          // >
          //   {quickRange &&
          //     quickRange.map(item => (
          //       <Button key={item} value={date_range_config[item]}>
          //         {_$(item)}
          //       </Button>
          //     ))}
          // </ButtonGroup>
          <Select
            width={120}
            placeholder={_$('时间范围')}
            value={range}
            on$change-value={(_c, val) => {
              btnChange(val)
            }}
          >
            {quickRange.map(item => (
              <Option key={date_range_config[item]} value={date_range_config[item]}>
                {_$(item)}
              </Option>
            ))}
          </Select>
        )}
        <Datepicker
          clearable={true}
          {...datepickerProps}
          range
          type="datetime"
          value={dateValue}
          on$change-value={handleChangeValue}
          on$change-_value={selectStart}
          onChange={handleChange}
          minDate={disabledDate.start}
          maxDate={disabledDate.end}
          shortcuts={showShortcuts ? renderShortcuts : []}
          style={{ width: '320px' }}
        />
        {realoadIcon && !!range && (
          <Icon
            className="ion-refresh cursor-pointer"
            onClick={() => {
              reloadDate()
            }}
          />
        )}
      </div>
    )
  }
)

export default styled(QuickRangeDate)`
  display: flex;
  align-items: center;
  .ion-refresh {
    margin-left: 16px;
  }
  .k-btns:not(.k-vertical) > .k-btn:not(:only-child):last-child {
    border-radius: 0;
  }
  .k-datepicker {
    margin-left: -1px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
`
